import { useState, useEffect } from 'react'
import { FormControl, RadioGroup, Box, FormControlLabel, Radio } from '@material-ui/core'

const MultipleChoices = (props) => {
  const { options, onSelect, answer, readonly } = props

  const [selected, setSelected] = useState(answer ?? null)

  const handleSelect = (e) => {
    if (readonly) return
    setSelected(e.target.value)
  }

  useEffect(() => {
    onSelect(selected)
  }, [selected, onSelect, answer])

  useEffect(() => {
    setSelected(answer)
  }, [answer])

  return (
    <FormControl component="fieldset">
      <RadioGroup className="presentation_options" aria-label="options" name="options" value={selected} onChange={handleSelect}>
        {options?.length > 0 &&
          options.map((o) => (
            <Box key={o.id} className="presentation__option-item">
              <Box>
                <FormControlLabel value={o.id} control={<Radio />} label={o.text} />
              </Box>
              {o.img !== undefined &&
                <Box>
                  <img src={o.img} alt="Question description" />
                </Box>
              }
            </Box>
          ))
        }
      </RadioGroup>
    </FormControl>
  )
}

export default MultipleChoices